import { Link, Flex } from "@radix-ui/themes";
import React from "react";
import PaymentDialog from "components/PaymentDialog";
import Profile from "components/Profile";
import SendFeedbackDialog from "components/SendFeedbackDialog";
import { DiscordLogoIcon } from "@radix-ui/react-icons";

const NavBar = () => {
  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        height: "50px",
        width: "100%",
        backgroundColor: "black",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 1000, // ensures the navbar stays on top of other content
      }}
    >
      <div
        style={{
          paddingLeft: "15px",
          fontFamily: "'Bungee Hairline', sans-serif",
          fontWeight: 600,
          fontStyle: "normal",
        }}
      >
        <a
          href="https://www.iamtellos.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/static/assets/tellos_p_circle.png"
            alt="Tellos AI Logo"
            style={{
              width: "50px",
              height: "50px",
              marginTop: "5px",
              objectFit: "contain",
              cursor: "pointer",
            }}
          />
        </a>
      </div>
      <div>
        <Flex gap="6" align="center">
          {/* <Button
            size="2"
            variant="ghost"
            style={{ width: "100px", cursor: "pointer" }}
          >
            Home
          </Button> */}
          {/* <Button
            size="2"
            variant="ghost"
            style={{ width: "100px", cursor: "pointer" }}
          >
            Marketplace
          </Button> */}
          {/* Disable Payments for now  */}
          {/* <PaymentDialog /> */} 
          <SendFeedbackDialog />
        </Flex>
      </div>
      <div style={{ paddingRight: "10px" }}>
        <Flex align="center" gap="3">
          <a
            href="https://discord.gg/BCVeXyEyUk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <DiscordLogoIcon
              style={{ marginTop: "0.5em", cursor: "pointer" }}
            />
          </a>
          <Link
            href="mailto:smartaipodcast@gmail.com"
            style={{ textDecoration: "underline" }}
          >
            Contact
          </Link>
          <Profile />
        </Flex>
      </div>
    </div>
  );
};

export default NavBar;
